export default "__VITE_ASSET__Cr2IsS1h__"